import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      authCheck: true,
    },
    component: function () {
      return import('@/views/Home.vue')
    }
  },
  {
    path: '/login',
    name: 'login',
    component: function () {
      return import('@/views/auth/Login.vue')
    }
  },
  {
    path: '/company',
    name: 'company',
    meta: {
      authCheck: true,
    },
    component: function () {
      return import('@/views/Company.vue')
    }
  },
  {
    path: '/office',
    name: 'office',
    meta: {
      authCheck: true,
    },
    component: function () {
      return import('@/views/Office.vue')
    }
  },
  {
    path: '/position',
    name: 'position',
    meta: {
      authCheck: true,
    },
    component: function () {
      return import('@/views/Position.vue')
    }
  },
  {
    path: '/employee',
    name: 'employee',
    meta: {
      authCheck: true,
    },
    component: function () {
      return import('@/views/Employee.vue')
    }
  },
  {
    path: '/attendance',
    name: 'attendance',
    meta: {
      authCheck: true,
    },
    component: function () {
      return import('@/views/Attendance.vue')
    }
  },
  {
    path: '/cuti',
    name: 'cuti',
    meta: {
      authCheck: true,
    },
    component: function () {
      return import('@/views/Cuti.vue')
    }
  },
  {
    path: '/reimburse',
    name: 'reimburse',
    meta: {
      authCheck: true,
    },
    component: function () {
      return import('@/views/Reimburse.vue')
    }
  },
  {
    path: '/user',
    name: 'user',
    meta: {
      authCheck: true,
    },
    component: function () {
      return import('@/views/User.vue')
    }
  },
  {
    path: '/setting',
    name: 'setting',
    meta: {
      authCheck: true,
    },
    component: function () {
      return import('@/views/Setting.vue')
    }
  },
  {
    path: '/callback',
    name: 'callback',
    component: function () {
      return import('@/views/auth/Callback.vue')
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: function () {
      return import('@/views/NotFound.vue')
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const preferences = window.localStorage.getItem('preferences');
  const authData = preferences ? JSON.parse(preferences) : null;
  const isLoggedIn = !!authData;

  if (to.meta.authCheck && !isLoggedIn) {
    // Butuh login, tapi belum login >>> redirect ke login
    if (to.name !== 'login') {
      return next({ name: 'login' });
    }
    return next();
  }

  if (to.name === 'login' && isLoggedIn) {
    // Sudah login tapi ke login page >>> redirect ke home
    return next({ name: 'home' });
  }
  // skipp
  return next();
})

export default router
